export default __webpack_public_path__ + "volume_off-1200-44f4c9d71b1f404bb36d4695e755d83e.png";